import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum PanelClientsEditAccountsResolverErrorStatesEnum {
    GetTradingClientFailed = ErrorStateScheduleEnum.PanelClientsEditAccountsResolverStatesStartIndex,
    TradingClientNotFound
}
